import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthProvider';

export const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const { user, loading, onboardingCompleted } = useAuth();
  const location = useLocation();

  const isPublicRoute = [
    '/auth/error',
    '/auth/confirm-email',
    '/dev/components',
    '/login'
  ].includes(location.pathname) ||
    location.pathname.startsWith('/onboarding');

  if (loading) return null;

  if (!user && !isPublicRoute) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (user && !user.email_confirmed_at) {
    return <Navigate to="/auth/confirm-email" replace state={{ email: user.email }} />;
  }

  if (user && !onboardingCompleted) {
    if (location.pathname !== '/onboarding/tutorial') {
      return <Navigate to="/onboarding/tutorial" replace state={{ from: location }} />;
    }
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
